import React from 'react';
import { Home, Zap, ShoppingCart, User, ChevronRight, Bell, Shield, Globe, ShoppingBag, CreditCard, HelpCircle,LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';

// --- Mock User Data ---
const mockUser = {
    name: "Chris Aaron",
    email: "chrisaaron@gmail.com",
    profileImageUrl: "https://placehold.co/100x100/4c72ef/ffffff?text=CA", // Placeholder image for Chris Aaron
    profileProgress: 1, // 1 out of 3 steps complete
    totalSteps: 3,
    nextStepLabel: "Verify Email Address",
};

// --- Sub Components ---

/**
 * Reusable setting row item.
 */
const SettingsItem = ({ label, icon: Icon,setActiveScreen ,name,onClick}) => (
    <div 
        className="flex items-center justify-between py-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition"
        // onClick={() => console.log(`Clicked ${label}`)}
      // Use onClick if provided, otherwise use setActiveScreen
        onClick={onClick ? onClick : () => setActiveScreen && setActiveScreen(name)}
    >
        <div className="flex items-center">
            {/* Icon is optional, not present in the image, but kept for future expansion */}
            {Icon && <Icon className="w-5 h-5 text-gray-500 mr-3" />}
            <span className="text-sm font-medium text-gray-700">{label}</span>
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400" />
    </div>
);

// --- Main Screen Component ---
const LOGOUT_API_URL = `${API_BASE_URL}/auth/logout`;
const ProfileScreen = ({setActiveScreen,authToken,userSession,onLogoutSuccess}) => {


    const navigate = useNavigate()


    const handleLogout = async () => {
        if (!authToken) {
            console.error("Logout failed: Missing authentication token.");
            alert("Could not log out: Missing session token.");
           if (onLogoutSuccess) onLogoutSuccess();
            return;
        }

        try {
            console.log("Attempting to log out...");
            const response = await fetch(LOGOUT_API_URL, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`, // Assuming your API requires a Bearer token
                },
                    // credentials: "include" 
                // Depending on your API, you might need a request body (e.g., refreshToken)
                // body: JSON.stringify({ deviceId: 'unique-id' }), 
            });

            // The API might return 200/204 on success or 401 if token is invalid
            if (response.ok || response.status === 204) {
                console.log("Logout successful on server.");
                if (onLogoutSuccess) onLogoutSuccess();
            } else {
                // Handle API error response
                const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
                console.error("Logout API Error:", errorData.message);
                alert(`Logout failed: ${errorData.message || response.statusText}`);
            }

        } catch (error) {
            console.error("Network or Fetch Error during logout:", error);
            alert("A network error occurred during logout.");
        }
    };
    console.log(userSession,'setuser')
    const progressPercent = (mockUser.profileProgress / mockUser.totalSteps) * 100;

    return (
        <div className="min-h-screen flex justify-center bg-gray-100 font-sans">
            <div className="w-full max-w-md bg-white shadow-2xl overflow-hidden flex flex-col h-screen">
                
                {/* Fixed Top Area (Blue Header) */}
                <header 
                    className="relative p-5 pt-10 pb-8 rounded-b-[25px] bg-[#307CF8]"
                    // style={{ backgroundImage: 'linear-gradient(to right, #4C72EF, #2D58E9)', boxShadow: '0 4px 10px rgba(45, 88, 233, 0.5)' }}
                >
                    {/* User Info */}
                    <div className="flex items-center mb-6">
                        <img 
                            src={mockUser.profileImageUrl}
                            alt={userSession.name}
                            className="w-16 h-16 rounded-full border-4 border-white object-cover"
                        />
                        <div className="ml-4 text-white">
                            <h2 className="text-xl font-bold">{userSession.name}</h2>
                            <p className="text-sm font-light opacity-80">{userSession.email}</p>
                        </div>
                    </div>

                    {/* Profile Completion Card (Clickable) */}
                    <div 
                        className="bg-[#2175FF] p-3 rounded-lg flex justify-between items-center shadow-lg cursor-pointer"
                        onClick={() => console.log('Go to profile completion steps')}
                    >
                        <div className="flex-1">
                            <p className="text-sm font-semibold text-[#F8F8F8] mb-1">
                                Complete Your Profile!
                            </p>
                            
                            {/* Progress Bar */}
                            <div className="h-1 bg-[#6E8CF9] rounded-full mb-1">
                                <div 
                                    className="h-full bg-white rounded-full transition-all duration-500"
                                    style={{ width: `${progressPercent}%` }}
                                ></div>
                            </div>

                            <p className="text-xs text-[#B2C6FE]">
                                ({mockUser.profileProgress}/{mockUser.totalSteps}) {mockUser.nextStepLabel}
                            </p>
                        </div>
                        <ChevronRight className="w-5 h-5 text-white ml-4" />
                    </div>
                </header>

                {/* Main Content Scrollable Area */}
                <main className="flex-1 overflow-y-auto px-5 pt-6 pb-20">
                    
                    {/* APP SETTINGS Section */}
                    <section className="mb-8">
                        <h3 className="text-xs font-semibold text-gray-400 mb-2 tracking-widest">APP SETTING</h3>
                        <div className="bg-white rounded-xl divide-y divide-gray-100 px-4">
                            <SettingsItem label="Profile Settings" icon={User} />
                            <SettingsItem label="Notification" icon={Bell} />
                            <SettingsItem label="Security Settings" icon={Shield} />
                            <SettingsItem label="Language" icon={Globe} />
                           
                               <SettingsItem label="My orders" icon={ShoppingBag} setActiveScreen={setActiveScreen} name="order"/> 
                            {/* <SettingsItem label="KYC / Update" icon={CreditCard} setActiveScreen={setActiveScreen} name="kycupdate" /> */}
                            <SettingsItem label="KYC / Update" icon={CreditCard}  name="kycupdate" />
                           {/* --- LOGOUT ITEM WITH API CALL --- */}
                            <SettingsItem 
                                label="Logout" 
                                icon={LogOut} 
                                name="logout" 
                                onClick={handleLogout} 
                            />
                        </div>
                    </section>


                    {/* GENERAL INFO Section */}
                    <section className="mb-8">
                        <h3 className="text-xs font-semibold text-gray-400 mb-2 tracking-widest">GENERAL INFO</h3>
                        <div className="bg-white rounded-xl divide-y divide-gray-100 px-4">
                            <SettingsItem label="Support / Raise Issue" icon={HelpCircle} />
                            {/* You could add Logout here if needed */}
                        </div>
                    </section>

                </main>

          
            </div>
        </div>
    );
};

export default ProfileScreen;
